import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import DomainData from './pages/DomainData';
import AdminLayout from './layouts/AdminLayout';
import './App.css';

function App() {
  return (
    <BrowserRouter basename="/stolity-admin">
      <Routes>
        {/* Redirect root to login */}
        <Route path="/" element={<Navigate to="/login" />} />

        {/* Login route */}
        <Route path="/login" element={<Login />} />

        {/* All routes that need AdminLayout */}
        <Route element={<AdminLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/domain-data" element={<DomainData />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
